import { keyframes } from 'styled-components';
import { styled, component } from '../../../utils/style';
import { Format, StyleColor } from '../../../utils/styles-constants';
import { Button } from '../../../components/Button/styles';
import { ParametersPageButton } from '../../ParametersPage/styles';
import { ActionButton } from '../../../utils/driveItem';

interface DriveItemDownloadButtonProps {
	isFlickering: boolean;
	color: string;
	action: ActionButton;
}

const flicker = (color: string) => keyframes`
	0% {fill: ${color}; opacity:0;}
	25% {fill: ${color}; opacity:0.5;}
	50% {fill: ${color}; opacity:1;}
`;

const iconStyle = `
	cursor: pointer;
	& > svg {
		height: 30px;
		width: 30px;
		transition: all 0.2s;
	}
`;

const DownloadButtonVariants: ({}) = {
	['Bar']: styled<DriveItemDownloadButtonProps>()(Button.extend, 'DownloadButton')`
		margin: 20px 5px;
		${ props => props.action === ActionButton.Update
			? `& > svg {
					height: 30px;
					width: 30px;
					fill: ${StyleColor.Blue};
				}

				@media ${Format.Smartphone} {
					flex-basis: 25%;
				}`

			: `	@media ${Format.Smartphone}, ${Format.Tablet}{
					flex: 0 0 content;
				}
			`}
	`,
	['Icon']: styled<DriveItemDownloadButtonProps>()(component.div, 'DownloadButton')`
		${iconStyle}
		& > svg {
			${ props => props.isFlickering ? `animation: ${flicker(props.color)} 1s linear infinite;` : ''}
			fill: ${props => props.theme.primary.iconsColor};
		}
	`,
	['IconBold']: styled<DriveItemDownloadButtonProps>()(component.div, 'DownloadButton')`
		${iconStyle}
		& > svg {
			${ props => props.isFlickering ? `animation: ${flicker(props.color)} 1s linear infinite;` : ''}
		}
	`,
	['ParametersPage']: styled()(ParametersPageButton.extend, 'DownloadAllButton')`
		background-color: ${StyleColor.Grey800};
		border-color: ${StyleColor.Grey800};

		&:hover {
			background-color: ${StyleColor.Grey650};
			border-color: ${StyleColor.Grey650};
		}
	`
};

export { DownloadButtonVariants };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DownloadButton/styles.ts